import {html, css, LitElement,} from "../../admin/script/libs/lit.dist.js";
import {cancelDomEvent} from "../../admin/script/util/browser.js";

class PkShowMore extends LitElement {

    // language=CSS
    static styles = css`
        a {
            color: var(--color, var(--bs-link-color));
            font-size: var(--font-size, 0.8rem);
        }
        .d-none {
            display: none;
        }
    `;

    static properties = {
        show: {type: Boolean},
        label: {type: String},
    };

    constructor() {
        super();
        this.label = '[Pokaż więcej]';
    }

    render() {
        return html`
            <slot class="${!this.show ? 'd-none' : ''}"></slot>
            ${!this.show ? html`
                <a href="#" @click="${cancelDomEvent(() => this.show = true)}">
                    ${this.label}
                </a>
            ` : null}
        `;
    }
}

window.customElements.define('pk-show-more', PkShowMore);
